

const Datacart = {
    DoctorDetails:[
        {   
            id: 111, 
            Name:'Dr. Grayson Pierson', 
            img:require('./Doctors Images/Dr.-Grayson-Pierson.png'), 
            descriptionD1:"Dr. Pierson is a 1996 graduate of The University of Iowa College of Dentistry. Through her dedication and commitment",
            descriptionD2:'Dr. Pierson is a 1996 graduate of The University of Iowa College of Dentistry. Through her dedication and commitment to continue education, we are able to offer you and your family the high level of care you are looking for, in a pleasant and relaxed environment. Our friendly staff, warm office, and caring attitude will put you at ease when you come into our office.'},
        {
            id: 112, 
            Name:'Dr. Ash', 
            img:require('./Doctors Images/Dr.-Ash.jpg'),
            descriptionD1:"We’d like to formally introduce you to Dr. Ashwath Gowda. He is our implant specialist and he is here to serve.",
            descriptionD2:'We’d like to formally introduce you to Dr. Ashwath Gowda. He is our implant specialist, he is here to serve those in need of replacing a tooth in the case one need’s to be extracted. Dr. Ash is very prominent and precise when it comes to the implant for the patient’s need’s. From, single implants to implanted supported dentures as well as extractions. He will have a solution for you. He is here to provide for our office every Friday. Please call the office for a consultation. We look forward to treating you' 
        },
        {
            id: 113, 
            Name:'Dr. Loretta Gillmore', 
            img:require('./Doctors Images/doctor-gilmore.jpg'), 
            descriptionD1:"Dr. Gilmore is a fun, high energy oral surgeon whose specialty includes wisdom teeth removal, impacted teeth.",
            descriptionD2:'Dr. Gilmore is a fun, high energy oral surgeon whose specialty includes wisdom teeth removal, impacted teeth, and exposures, a procedure to remove gum tissue for proper tooth eruption. Her dedication to excellence in dentistry and oral surgery brings patients to our practice from all over the Inland Empire. Dr Gilmore’s kind and generous spirit is evidenced by her volunteer service'
        }
        
    ]

}
export default Datacart;